import ToggleItem from './toggle_item';

export default class BackgroundImg extends ToggleItem {
  constructor() {
    super('backgroundimage');
  }
}
